import {
  GET_USAGE_DETAILS,
  SET_USAGE_DETAILS
} from "./actionTypes"

const initialState = {
  responseMessage: null,
  responseStatus: null,
  loading: false,
  usageDetails: {}


}

const Usage = (state = initialState, action) => {
  switch (action.type) {

    case GET_USAGE_DETAILS:
      state = {
        ...state,
        loading: true
      }
      break
    case SET_USAGE_DETAILS:
      state = {
        ...state,
        loading: false,
        responseMessage: action.payload?.responseMessage,
        responseStatus: action.payload?.responseStatus,
        usageDetails: action.payload?.usageDetails,


      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default Usage
